import type { i18nStringType } from "../../i18n/i18nString";
import type { PaymentStatus } from "@spwn/types";

const PAYMENT_STATUS: Record<PaymentStatus, i18nStringType> = {
  CANCEL: "settlementHistory.paymentStatus.cancelled",
  PAYSUCCESS: "settlementHistory.paymentStatus.success",
  RETURN: "settlementHistory.paymentStatus.refunded",
  UNPROCESS: "settlementHistory.paymentStatus.unprocessed",
};

const UNKNOWN: i18nStringType = "settlementHistory.paymentMethod.unknown";

export const getPaymentStatus = (
  paymentStatus: PaymentStatus | null
): i18nStringType => {
  // Firestoreの値をもとに文言を算出しているため、存在しない決済種別が来た場合に備えてデフォルト値を設定
  if (paymentStatus === null) return UNKNOWN;
  return PAYMENT_STATUS[paymentStatus] ?? UNKNOWN;
};
